import {
  AuthFlowType,
  B2BOAuthProviders,
  B2BProducts,
  StytchB2BUIConfig,
} from '@stytch/react/b2b';

const stytchCookieDomain =
  import.meta.env.VITE_STYTCH_COOKIE_DOMAIN || 'localhost';
export const stytchSessionDurationMinutes =
  import.meta.env.VITE_STYTCH_SESSION_DURATION_MINUTES || 1440; // 24 hours

const baseUrl = window.location.origin;

export const discoveryConfig: StytchB2BUIConfig = {
  products: [
    B2BProducts.oauth,
    B2BProducts.emailMagicLinks,
    B2BProducts.passwords,
    // B2BProducts.emailOtp,
    // B2BProducts.sso,
  ],
  sessionOptions: { sessionDurationMinutes: stytchSessionDurationMinutes },
  oauthOptions: {
    providers: [{ type: B2BOAuthProviders.Google }],
    loginRedirectURL: `${baseUrl}/authenticate`,
    signupRedirectURL: `${baseUrl}/authenticate`,
    discoveryRedirectURL: `${baseUrl}/authenticate`,
  },
  emailMagicLinksOptions: {
    loginRedirectURL: `${baseUrl}/authenticate`,
    signupRedirectURL: `${baseUrl}/authenticate`,
    discoveryRedirectURL: `${baseUrl}/authenticate`,
  },
  passwordOptions: {
    loginRedirectURL: `${baseUrl}/authenticate`,
    resetPasswordRedirectURL: `${baseUrl}/authenticate`,
  },
  authFlowType: AuthFlowType.Discovery,
  disableCreateOrganization: true,

  directLoginForSingleMembership: {
    /**
     * Whether or not direct login for single membership is enabled.
     */
    status: true,
    /**
     * If enabled, logs user in directly even if they have pending invite to a different organization
     */
    ignoreInvites: true,
    /**
     * If enabled, logs user in directly even if they have organizations they could join via JIT provisioning
     */
    ignoreJitProvisioning: true,
  },
};

export const discoveryPresentation = {
  theme: {
    'color-scheme': 'light' as const,
    'container-width': '500px',
  },
};

export const stytchClientOptions = {
  cookieOptions: {
    opaqueTokenCookieName:
      import.meta.env.VITE_ENV == 'prod'
        ? 'admin_stytch_session'
        : `admin_stytch_session_${import.meta.env.VITE_ENV}`,
    jwtCookieName:
      import.meta.env.VITE_ENV == 'prod'
        ? 'admin_stytch_session_jwt'
        : `admin_stytch_session_jwt_${import.meta.env.VITE_ENV}`,
    path: '/',
    availableToSubdomains: true,
    domain: stytchCookieDomain,
  },
};
